<template>
    <div class="custome_div addtext_rotation_wrap">
        <div class="addtext_font rotation add_font_mobile_w">
            <div class="form-group">
                <div class="range">
                    <!-- eslint-disable -->
                     <label>Rotation</label><span class="highlight"></span>
                    <input
                        v-model="value"
                        v-on:change="setValue"
                        id="rotationValue"
                        type="range"
                        value="0"
                        min="-360"
                        max="360"
                        class="input_type_rang_custom"
                    />
                    <!-- eslint-enable -->
                </div>
                
            </div>
        </div>

        <div
            :class="
                (mTop === 0 ? 'setwidth_top_margin ' : ' ') +
                'addtext_color font-size_add rot_value'
            "
        >
            <div class="form-group">
                <!-- eslint-disable -->
                <input
                    v-on:change="setValue"
                    type="number"
                    v-model="value"
                    id="rotationValueInput"
                    required="required"
                    placeholder="0"
                    min="-360"
                    max="360"
                    class="range_slider_input span2 form-control bg-whit"
                />
                <!-- eslint-enable -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    /* eslint-disable */
    name: "Rotation",
    /* eslint-enable */
    props: ["value", "mTop"],
    data: () => {
        return {};
    },
    watch: {
        value: function (newData, oldData) {
            /* eslint-disable */
            if (newData != oldData) this.value = newData;
            /* eslint-enable */
        }
    },
    methods: {
        setValue(e) {
            this.$emit("set-value", Number(e.target.value));
        }
    }
};
</script>

<style scoped>
    .design_studio_up .clipart_panel .addtext_font .range input[type=range] {
        position: absolute;
        left: 0;
        top: 20px;
        width: 75%;
    }
    .design_studio_up .clipart_panel .font-size_add .form-group .range_slider_input {
        position: relative;
        top: -60px;
    }
    .design_studio_tool .clipart_panel .rt-edit-template .custome_div .setwidth_top_margin{
        margin-top: 0px !important;
    }
      .design_studio_tool .clipart_panel .addtext_font.rotation {
             border-bottom: 1px solid #BEBEBE99;
            padding-bottom: 35px;
      }
      @media only screen and (min-width: 768px) and (max-width: 1919px) {
    .design_studio_tool .addtext_font {
        float: left;
        width: 100% !important;
    }
}
</style>
